import React, { useState } from 'react';
import { useStore } from '../../context/StoreContext';
import CheckoutModal from '../Checkout/CheckoutModal';

export default function CartDrawer() {
  const { 
    cartOpen, 
    setCartOpen, 
    cart, 
    updateCartQuantity, 
    removeFromCart,
    requireLogin
  } = useStore();
  
  const [showCheckout, setShowCheckout] = useState(false);
  const formatPrice = (n) => '₹' + n.toLocaleString('en-IN');

  const subtotal = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);
  const total = subtotal;

  const handleCheckout = () => {
    requireLogin(() => {
      setCartOpen(false);
      setShowCheckout(true);
    });
  };

  if (!cartOpen) return null;

  return (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setCartOpen(false)}></div>
      <div className="absolute right-0 top-0 h-full w-full max-w-[420px] bg-white shadow-2xl flex flex-col">
        <div className="p-5 border-b flex items-center justify-between">
          <h3 className="font-bold text-lg">Your Bag ({cart.reduce((s, i) => s + i.qty, 0)})</h3>
          <button onClick={() => setCartOpen(false)} className="w-9 h-9 grid place-items-center rounded-xl hover:bg-slate-100">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto p-5 space-y-4">
          {cart.length === 0 ? (
            <div className="h-full grid place-items-center text-center py-20">
              <div>
                <i className="ri-shopping-bag-line text-5xl text-slate-300"></i>
                <p className="mt-3 font-semibold">Your bag is empty</p>
                <p className="text-sm text-slate-500">Add products you love</p>
              </div>
            </div>
          ) : (
            cart.map(item => (
              <div key={`${item.id}-${item.size}`} className="flex gap-3 p-3 rounded-2xl border">
                <img src={item.img} className="w-20 h-24 object-cover rounded-xl" alt={item.name} />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-bold text-slate-500">{item.brand}</p>
                  <p className="text-sm font-semibold leading-snug line-clamp-1">{item.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">Size: {item.size}</p>
                  <div className="mt-2 flex items-center justify-between">
                    <div className="flex items-center border rounded-xl">
                      <button onClick={() => updateCartQuantity(item.id, item.size, -1)} className="w-8 h-8 grid place-items-center">−</button>
                      <span className="w-8 text-center text-sm font-semibold">{item.qty}</span>
                      <button onClick={() => updateCartQuantity(item.id, item.size, 1)} className="w-8 h-8 grid place-items-center">+</button>
                    </div>
                    <span className="font-bold text-sm">{formatPrice(item.price * item.qty)}</span>
                  </div>
                </div>
                <button onClick={() => removeFromCart(item.id, item.size)} className="self-start text-slate-400 hover:text-rose-600">
                  <i className="ri-close-line"></i>
                </button>
              </div>
            ))
          )}
        </div>
        
        {cart.length > 0 && (
          <div className="border-t p-5 space-y-3 bg-slate-50">
            <div className="flex justify-between text-sm">
              <span className="text-slate-600">Subtotal</span>
              <span className="font-semibold">{formatPrice(subtotal)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-600">Shipping</span>
              <span className="font-semibold text-emerald-600">FREE</span>
            </div>
            <div className="flex justify-between text-base font-bold pt-2 border-t">
              <span>Total</span>
              <span>{formatPrice(total)}</span>
            </div>
            <button 
              onClick={handleCheckout}
              className="w-full h-12 rounded-2xl bg-slate-900 text-white font-semibold hover:translate-y-[-1px] transition"
            >
              Checkout Securely
            </button>
            <p className="text-[11px] text-center text-slate-500">Safe & Secure Payments • 100% Authentic</p>
          </div>
        )}
      </div>
      
      {showCheckout && <CheckoutModal onClose={() => setShowCheckout(false)} />}
    </div>
  );
}